<script>
import { EventBus } from '@/allotment/bus'
import { warnApi } from '@/apis'
import XEUtils from 'xe-utils'

export default {
  data() {
    return {
      visible: false,
      rdeviceId: '',
      deviceType: '',
      belongFactory: '',
      deviceId: '',
      sn: '',
      count: { total: 0, unDeal: 0, deal: 0 },
      model: { id: null, name: '', advice: '' },
      id: '',
      remark: '',
      loading: false,
      loadingTable: false,
      talbe: { loading: false, list: [], total: 0, where: { pageNum: 1, pageSize: 10 } },
      type: 'total'
    }
  },

  computed: {
    //自定义列
    columns() {
      return [
        { type: 'seq', title: this.$t('table.seq'), width: 80 },
        { field: 'warnName', title: this.$t('main.log.warn.table.info'), sortable: true, minWidth: 180, slots: { default: 'warnName' } },
        { field: 'warnGrade', title: this.$t('main.log.warn.table.grade'), sortable: true, width: 120, slots: { default: 'grade' } },
        { field: 'warnTime', title: this.$t('main.log.warn.table.time'), sortable: true, width: 140, slots: { default: 'time' } },
        { field: 'warnReason', title: this.$t('main.log.warn.table.reason'), sortable: true, minWidth: 180 },

        { field: 'confirmer', title: this.$t('main.log.warn.table.handle'), sortable: true, width: 140 },
        { field: 'confirmTime', title: this.$t('main.log.warn.table.handleTime'), sortable: true, width: 140, slots: { default: 'handleTime' } },
        { field: 'remark', title: this.$t('main.log.warn.table.handleRemark'), sortable: true, width: 140 },
        { field: 'warnCode', title: this.$t('main.log.warn.table.code'), sortable: true, width: 140 }
      ]
    }
  },

  methods: {
    //打开详情
    open(data) {
      console.log(data);
      this.remark = ''
      this.loading = false
      this.talbe.loading = false
      this.talbe.list = []
      this.talbe.total = 0
      this.talbe.where.pageNum = 1
      this.talbe.where.pageSize = 10
      this.model = Object.assign({}, data)
      this.model.advice = (data.advice || '').replaceAll('hdkj_upload/', process.env.VUE_APP_API)
      this.id = data.id || ''
      this.remark = data.remark || ''
      this.rdeviceId = data.deviceId || ''
      this.deviceType = data.deviceType || ''
      this.belongFactory = data.belongFactory || ''
      this.deviceId = ''
      this.sn = ''
      this.type = 'total'

      this.count.total = 0
      this.count.unDeal = 0
      this.count.deal = 0

      this.loadCount()
      this.loadData()
      this.visible = true
    },

    // 获取统计
    loadCount() {
      warnApi.infoCount(this.model.id).then(result => {
        this.count.total = result.total || 0
        this.count.unDeal = result.unDeal || 0
        this.count.deal = result.deal || 0
      })
    },

    // 获取列表
    loadData() {
      this.talbe.loading = true
      this.talbe.total = 0
      this.talbe.list = []

      const where = { id: this.model.id , ...this.talbe.where }

      if(this.type === 'unhandle') {
        where.isDeal = 0
      } else if(this.type === 'handle') {
        where.isDeal = 1
      }

      warnApi.infoPage(where).then(result => {
        this.talbe.list = result.list || []
        this.talbe.total = result.totalSize || 0

        if(this.talbe.list.length > 0) {
          this.deviceId = this.talbe.list[0].deviceName || ''
          this.sn = this.talbe.list[0].sn || ''
        }

        if(this.id) {
          const currentItem = this.talbe.list.find(item => item.id == this.id)
          if(currentItem) {
            this.$nextTick(() => {
              this.$refs.tablesRef.setCurrentRow(currentItem)
              this.model.advice = ((this.$i18n.locale === 'zh' ? currentItem.warnAdvice : currentItem.warnEnAdvice) || '').replaceAll('hdkj_upload/', process.env.VUE_APP_API)
              this.remark = currentItem.remark || ''
            })
          }
        }
      }).finally(() => {
        this.talbe.loading = false
      })
    },

    //每页大小改变事件
    onSizeChange(size) {
      this.talbe.where.pageSize = size
      this.loadData()
    },

    //当前页改变事件
    onCurrentChange(current) {
      this.talbe.where.pageNum = current
      this.loadData()
    },

    // 设备详情
    onDevice() {
      let type = '';

      if(this.rdeviceId == 'V2G') {
        type = 'v2g'
      } else if(this.deviceType == 'SWITCHBOX') {
        type = 'switchbox'
      } else if(this.deviceType == 'INVERTER') {
        type = 'inverter'
      } else if(this.deviceType == 'BATTERY') {
        type = 'battery'
      } else if(this.deviceType == 'SOLARPANELS') {
        type = 'solar'
      } else if(this.deviceType == 'CHARGESTATION') {
        type = 'charge'
      }

      if(type) this.$router.push({ path: '/guide/device/detail?id=' + this.rdeviceId + '&type=' + type + '&belongFactory=' + (this.belongFactory || '') })
    },

    // 操作建议
    onAdvise(row) {
      this.id = row.id
      this.remark = row.remark || ''
      this.model.advice = ((this.$i18n.locale === 'zh' ? row.warnAdvice : row.warnEnAdvice) || '').replaceAll('hdkj_upload/', process.env.VUE_APP_API)
    },

    // 下载
    onDownload() {
      this.visible = false
      this.$router.push({ path: '/main/file' })
    },

    //类型点击事件
    onType(value) {
      this.type = value
      this.loadData()
    },

    // 导出
    onExport() {
      const where = { id: this.model.id , ...this.talbe.where }

      if(this.type === 'unhandle') {
        where.isDeal = 0
      } else if(this.type === 'handle') {
        where.isDeal = 1
      }

      warnApi.infoExport(where).then(result => {
        const content = result.headers['content-disposition']
        let fileName = content ? decodeURI((content.split('='))[1]) : null
        if(fileName) fileName = fileName.replaceAll('utf-8\'\'', '')

        const blob = new Blob([result.data], {type: 'application/x-excel'})
        const url = window.URL.createObjectURL(blob)
        const downloadLink = document.createElement('a')
        downloadLink.href = url
        downloadLink.download = fileName || `${XEUtils.toDateString(Date.now(), 'yyyy-MM-dd')}.csv`
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
        window.URL.revokeObjectURL(url)
      })
    },

    // 确认事件
    onDefine() {
      warnApi.infoRemark({ id: this.id, remark: this.remark }).then(() => {
        this.$message.success(this.$t('base.success'))
        this.loadData()
        EventBus.$emit('warnChange', this.model.id)
      })
    }
  }
}
</script>

<template>
  <dialogs v-model="visible" width="80%" :define-close="false" :define="$store.getters.auth('log:warn:handle')" :loading="loading" :define-text="$t('warn.info.define')" class="warn-detail-dialogs" @define="onDefine">
    <template #title>
      <div class="el-dialog__title">
        {{ $t('warn.info.title') }} - {{ model.name }}（ID：{{ deviceId }}，SN：<el-button type="text" style="padding: 0;" class="el-dialog__title" @click="onDevice">{{ sn }}</el-button>）
      </div>
    </template>

    <div class="warn-detail">
      <div class="warn-detail-left">
        <div class="warn-detail-left-count">
          <div :class="['warn-detail-left-count-item', { 'active': type === 'total' }]" @click="onType('total')">{{ $t('warn.info.total') }}：{{ count.total || 0 }}</div>
          <div :class="['warn-detail-left-count-item', { 'active': type === 'unhandle' }]" @click="onType('unhandle')">{{ $t('warn.info.unhandle') }}：{{ count.unDeal || 0 }}</div>
          <div :class="['warn-detail-left-count-item', { 'active': type === 'handle' }]" @click="onType('handle')">{{ $t('warn.info.handle') }}：{{ count.deal || 0 }}</div>
        </div>

        <div class="warn-detail-left-table">
          <tables ref="tablesRef" id="warn-table" :loading="talbe.loading" :columns="columns" :data="talbe.list" :page="{ current: talbe.where.pageNum, size: talbe.where.pageSize, total: talbe.total }" @size-change="onSizeChange" @current-change="onCurrentChange" @refresh="loadData" @cell-click="onAdvise">
            <template #toolbar>
              <div class="warn-detail-left-table-toolbar">
                <el-button type="primary" plain size="small" @click="onExport">{{ $t('warn.info.export') }}</el-button>
              </div>
            </template>

            <template #grade="{ row }">{{ row.warnGrade == 0 ? $t('warn.grade_0') : (row.warnGrade == 1 ? $t('warn.grade_1') : row.warnGrade) }}</template>
            <template #time="{ row }">{{ row.warnTime ? $dayjs(row.warnTime).format('YYYY-MM-DD HH:mm:ss') : '' }}</template>
            <template #warnName="{ row }">{{ $i18n.locale === 'zh' ? row.warnName : row.warnEnName }}</template>
            <template #handleTime="{ row }">{{ row.confirmTime ? $dayjs(row.confirmTime).format('YYYY-MM-DD HH:mm:ss') : '' }}</template>
          </tables>
        </div>
      </div>

      <div class="warn-detail-right">
        <div class="warn-detail-right-content">
          <el-scrollbar style="height: 100%;">
            <div v-html="model.advice"></div>
          </el-scrollbar>
        </div>

        <div v-if="$store.getters.auth('log:warn:handle')" class="warn-detail-right-remark">
          <el-input v-model="remark" type="textarea" :rows="2" :placeholder="$t('table.remark_placeholder')"></el-input>
        </div>
      </div>
    </div>

    <template #footer>
      <el-button type="primary" plain size="medium" @click="onDownload">{{ $t('warn.info.download') }}</el-button>
    </template>
  </dialogs>
</template>

<style lang="scss" scoped>
.warn-detail-dialogs{
  ::v-deep(.el-dialog){
    height: 600px;
    .el-dialog__body{
      padding: 10px;
    }
  }
}

.warn-detail{
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;

  &-left{
    width: 600px;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    &-count {
      width: 100%;
      margin-bottom: 15px;
      display: flex;
      align-items: stretch;

      &-item{
        padding: 10px;
        flex: 1;
        margin-left: 10px;
        border: 1px solid rgba(144, 147, 153, 0.3);
        cursor: pointer;

        &.active{
          border-color: #026fe3;
        }

        &:first-child{
          margin-left: 0;
        }
      }
    }

    &-table{
      flex: 1;

      &-toolbar{
        width: 100%;
        padding-right: 15px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }

  &-right{
    flex: 1;
    padding-left: 20px;
    margin-left: 20px;
    height: 100%;
    overflow: hidden;
    border-left: 1px solid rgba(144, 147, 153, 0.3);
    display: flex;
    flex-direction: column;

    &-content{
      flex: 1;
      margin-bottom: 15px;
      overflow: hidden;
    }
  }
}
</style>
